var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/core-video-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg id=\"core-video-icon\" class=\"i-play-link c-product-tile-video__icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 37 37\">\n\t<path style=\"fill: #fff\" d=\"M13.4 10l14.8 8.5-14.8 8.6z\"></path>\n\t<circle style=\"fill: none; stroke: #fff; stroke-width: 1.5; stroke-miterlimit: 10;\" cx=\"18.5\" cy=\"18.5\" r=\"17.5\"></circle>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/core-video-icon.j2"] , dependencies)